module.exports = __webpack_public_path__ + "static/img/partner-gospower.40a5a82.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/productService/partner/partner-gospower.png
// module id = rOw9
// module chunks = 34